import { useEffect } from "react";

import { useAtom, useAtomValue } from "jotai";
import { selectedClientAtom } from "store";
import { selectedPackageUserAtom } from "store/UIBenefitsPage";

import { useGetEmployeeData } from "state/useGetEmployeeData";

import { useGetMsalUserEmail } from "./useGetMsalUserEmail";

export function useEmployee() {
  const userUniqueEmail = useGetMsalUserEmail();

  const selectedClient = useAtomValue(selectedClientAtom);
  const [selectedPackageUser, setSelectedPackageUser] = useAtom(selectedPackageUserAtom);

  const { data: employeeData, isLoading: employeeDataLoading } = useGetEmployeeData({
    clientInternalNumberGos: Number(selectedClient?.clientInternalNumberGos),
    countryCode: Number(selectedClient?.countryCode),
    enabled: !!selectedClient,
  });

  useEffect(() => {
    if (selectedPackageUser || !employeeData) return;
    setSelectedPackageUser({
      ...employeeData,
      value: userUniqueEmail || "",
      text: `${employeeData?.firstName} ${employeeData?.lastName}`,
    });
  }, [employeeData, selectedPackageUser]);

  return {
    employeeData,
    employeeDataLoading,
  };
}

export default useEmployee;
